// extracted by mini-css-extract-plugin
export default {"page":"oR","freeShippingContainer":"pR","customizeContainer":"qR","customizeHeader":"rR","fadein":"sR","customizeText":"tR","hidden":"uR","productcard":"vR","accordeonscontainer":"wR","freeShipping":"xR","mainpart":"yR"};
    if(module.hot) {
      // 1721922365351
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  